
<c-tag
    :label            = "label"
    :background-color = "color"
    :active           = "active"
    class             = "quality-flag"
/>
